/**
 * Действия для изменения ингредиентов:
 * Выполняется по действиям:
 *    @constructor/ADD_PORTION,
 *    @constructor/REMOVE_PORTION,
 *    @constructor/REMOVE_INGREDIENT,
 *    @catalog/REMOVE_INGREDIENT,
 * 
 */

export function changeIngredients(action, prevState, nextState) {
  let ingredient = {};

  const { id, variationId, ingredientId } = action.payload;

  switch (action.type) {
    case '@constructor/ADD_PORTION': {
      const good = nextState.pizzaConstructor.goods[id];

      ingredient = getIngredientForConstructor(good, action.payload, false);

      break;
    }

    case '@constructor/REMOVE_PORTION':
    case '@constructor/REMOVE_INGREDIENT': {
      const good = nextState.pizzaConstructor.goods[id];

      ingredient = getIngredientForConstructor(good, action.payload, true);

      break;
    }

    case '@catalog/REMOVE_INGREDIENT': {
      const findedItem = nextState.catalog.products.list.find(item => item.id === id);

      if (findedItem) {
        const findedVar = findedItem.variations.find(vari => vari.id === variationId);

        if (findedVar) {
          const findedIngred = findedVar.include_ingredients.find(ingr => ingr.id === ingredientId);
          ingredient = {
            name: findedIngred.name,
            removed: findedIngred.removed,
          };
        }
      }

      break;
    }

    default:
      break;
  }

  const outData = {
    event: 'UA event',
    eventCategory: 'Изменение ингредиентов',
    eventAction: ingredient.removed ? 'удаление' : 'добавление',
    eventLabel: (ingredient.name || '').toLowerCase(),
  };

  return outData;
}

function getIngredientForConstructor(findedItem, payload, isRemoved) {
  const { variationId, ingredientId, included } = payload;

  if (findedItem) {
    const findedVar = findedItem.variations.find(vari => vari.id === variationId);

    if (findedVar) {
      let findedIngred = {};

      if (!included) {
        findedIngred = findedVar.available_ingredients.find(ingr => ingr.id === ingredientId);
      } else {
        findedIngred = findedVar.include_ingredients.find(ingr => ingr.id === ingredientId);
      }

      if (findedIngred) {
        return {
          name: findedIngred.name,
          removed: isRemoved,
        };
      }
    }
  }

  return null;
}
